import {React}  from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

/* eslint-disable react/prop-types */
function DialogBox({openDialog, handleClose, onSubmit, text}){

  const handleYes = () => {
    if (onSubmit) {
      onSubmit();
    }
  };
    return (
    <div>
      <Dialog
        open={openDialog}
        onClose={()=>handleClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>NO</Button>
          <Button onClick={handleYes} autoFocus>
            YES
          </Button>
        </DialogActions>
      </Dialog>
        
    </div>

    )
}

export default DialogBox